import React, { SVGProps } from "react";

const SvgRoof9 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof012 dims 1">
      <path
        fill="#d7f2ff"
        d="M121.637 183.226v34.008l170.302-98.433V84.792l-170.302 98.434z"
      />
      <path
        fill="#fff"
        d="M121.637 183.286v33.948l-97.148-55.957v-34.309l97.148 56.318z"
      />
      <path
        fill="#d7f2ff"
        d="M211.847 172.497v35.236l63.067-36.52v-35.346l-63.067 36.63z"
      />
      <path
        fill="#fff"
        d="M211.847 172.497v35.236l-37.022-21.243v-35.598l37.022 21.605z"
      />
      <path
        fill="#1f75a9"
        d="M302.083 79.253 121.974 183.482l-8.45-109.829 89.384-51.543 99.175 57.143z"
      />
      <path
        fill="#48d7ff"
        d="m202.75 22.202-89.226 51.451-98.617 47.761L195.265 17.177l7.485 5.025z"
      />
      <path
        fill="#4cf1ff"
        d="M121.974 183.482 14.907 121.414l98.617-47.761 8.45 109.829z"
      />
      <path
        fill="#46e2ff"
        d="m176.175 151.981 35.608 20.553 10.323-62.713-38.122-22.076-7.809 64.236z"
      />
      <path
        fill="#257dad"
        d="m284.973 130.034-73.19 42.5 10.323-62.713 62.867 20.213z"
      />
      <path
        fill="#2580b4"
        d="m249.683 109.577 35.29 20.457-62.867-20.213-38.122-22.076 65.699 21.832z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M24.489 126.968v34.309l97.148 55.957 53.188-30.744 37.022 21.243 63.067-36.52v-35.346M278.816 126.442l13.123-7.641V84.792"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M211.847 172.497v35.236M174.825 186.49v-33.67"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="m113.524 73.653 89.384-51.543"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m176.175 151.981 7.809-64.236 38.122 22.076-10.259 62.676M284.973 130.034l-62.867-20.213M183.984 87.745l65.636 22.068M121.975 183.482l-8.451-109.829-98.617 47.761"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m249.683 109.577 35.29 20.457-73.126 42.463-35.672-20.516-54.2 31.501-107.068-62.068L195.265 17.177l7.643 4.933 99.176 57.143-52.401 30.324z"
        />
      </g>
      <path
        fill="none"
        stroke="#3f3f3f"
        strokeMiterlimit={10}
        d="M121.637 217.234v-34.008"
      />
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m98.167 231.71 17.096-9.881M1.831 174.819l18.061-10.5M4.954 173.199l133.49 76.951" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m160.682 237.558 44.542-25.723M134.492 252.683l17.609-10.169" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m231.837 219.758-14.022-8.106M295.399 183.18l-14.027-8.17" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m176.494 251.467-49.046-28.328M344.593 149.721l-172.267 99.338" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m347.565 151.05-43.171-24.936M298.159 122.525l-2.655-1.544" />
      </g>
      <text
        transform="translate(199.88 245.883)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <text
        transform="translate(64.39 121.878)"
        fontSize={16}
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <text
        transform="translate(308.36 121.218)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P3"}
      </text>
      <text
        transform="translate(150.205 123.21)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <text
        transform="translate(259.623 213.878)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <text
        transform="translate(316.313 179.612)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"E"}
      </text>
      <text
        transform="translate(111.086 252.94)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(45.025 214.869)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M4.781 169.214v7.77M102.291 225.512v7.769M138.661 246.51v7.769M172.325 245.182v7.769M227.451 213.355v7.769M291.017 176.655v7.769M345.01 145.482v7.77M310.811 91.211l-57.967 33.348M309.719 95.306l-6.728-3.885M298.316 137.603l-2.018-7.502M298.63 131.58c5.256-12.844 8.2-26.06 8.094-38.084"
      />
      <path
        d="M173.43 108.863a71.97 71.97 0 0 1-.574 8.894c-1.626 12.59-6.546 21.796-13.695 27.31"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M59.684 104.628a65.408 65.408 0 0 0 .517 8.779c1.638 12.672 6.979 21.538 14.687 26.21"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeDasharray={4}
        opacity={0.5}
        d="m167.014 157.336-53.483-83.703"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeMiterlimit={10}
        strokeDasharray={4}
        opacity={0.5}
        d="m67.402 152.369 46.129-78.736"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M178.347 111.747 119.02 77.241"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m54.324 107.762 50.55-29.121M63.169 106.849l-6.728-3.885M71.489 141.261l6.729-3.885"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m162.516 146.901-6.728-3.884M176.809 107.241l-6.728 3.885"
      />
      <g fill="none" stroke="#fff" strokeMiterlimit={10} opacity={0.5}>
        <path d="m227.964 113.22 1.73 1.003" />
        <path
          strokeDasharray="3.76068 3.76068"
          d="m232.948 116.11 17.893 10.376"
        />
        <path d="m252.467 127.429 1.73 1.003" />
      </g>
      <g fill="none" stroke="#fff" strokeMiterlimit={10} opacity={0.5}>
        <path d="M248.306 148.622v-2" />
        <path strokeDasharray="3.41734 3.41734" d="M248.306 143.205v-18.796" />
        <path d="M248.306 122.701v-2" />
      </g>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m304.148 136.229-14.678-4.721M297.698 134.119l.932-2.538"
      />
    </g>
  </svg>
);

export default SvgRoof9;
